<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">

    <el-card class="mt20">
      <span class="label">导入DW_SPU_ID：</span>
      <div class="upload-wrap">
        <el-button size="small" type="primary" icon="el-icon-upload">上传</el-button>
        <input @change="(e) => changeFile(e)" accept=".xlsx" type="file">
      </div>
      <!-- <el-button type="text" class="ml10" @click="onClickTemplate()">下载模板</el-button> -->
      <p class="upload-tip">支持扩展名：.xlsx</p>
    </el-card>
  </div>
</template>

<script>
import { downloadUrlFile } from '@/utils/functions';
import {
  importPoizonSpuIdPool
} from '@/api/trace';

export default {
  data() {
    return {
      fullscreenLoading: false,
    };
  },
  mounted() {
  },
  methods: {
    async changeFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (!/\.xlsx$/.test(String(file.name).toLowerCase())) {
          this.$message.error('上传文件格式非法，请上传xlsx文件');
          return;
        }
        this.fullscreenLoading = true;

        const fd = new FormData();
        fd.append('file', file);
        const res = await importPoizonSpuIdPool(fd);
        this.fullscreenLoading = false;

        if (res.data && res.data.success) {
          this.$message.success('导入成功');
        } else {
          this.$message.error(res.data && res.data.message || '系统异常');
        }
      }
      e.target.value = '';
    },
    // onClickTemplate() {
    //   spuMadeInTemplate().then(res => {
    //     if (res.data.success && res.data.data) {
    //       downloadUrlFile(res.data.data);
    //     } else {
    //       this.$message.error(res.data.message || '系统错误，请稍后再试');
    //     }
    //   })
    // },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.label {
  font-size: 14px;
  font-weight: bold;
}
.upload-wrap {
  position: relative;
  display: inline-block;

  input {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 10;
  }
}
.upload-tip {
  margin-top: 10px;
  margin-left: 93px;
}
</style>
